import { Component, OnInit } from "@angular/core";
import { SellerIncomeReportService } from "./seller-income-report.service";
import * as moment from 'moment';
import { Report } from '../../report';

@Component({
  selector: 'app-seller-income',
  templateUrl: './seller-income.component.html',
  styleUrls: ['./seller-income.component.scss']
})

export class SellerIncomeComponent implements OnInit {
  totalEntries: number = 0;
  limit: number = 0;

  tableColumns: string[] = [
    "refNumber",
    "transactionType",
    "amount",
    "businessName",
    "paymentOption",
    "dateFormatted"
  ];

  displayTableColumns = {
    refNumber: "Reference Number",
    transactionType: "Transaction Type",
    amount: "Amount",
    businessName: "Business Name",
    paymentOption: "Payment Option",
    dateFormatted: "Date",
  };

  sellerIncomeReportData: any[] = [];
  totalNumberOfRecords = 0;
  requestBody: Report = {};
  loading = false;

  constructor(
    public sellerIncomeReportService: SellerIncomeReportService
  ) { }

  async ngOnInit() {
    this.sellerIncomeReportService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    let dateNow = new Date();
    this.requestBody.filterOptions = {
      //@ts-ignore
      createdAt: this.getFormatedDate(dateNow, dateNow)
    };

    await this.updateTable();
  }

  async updateTable() {
    this.sellerIncomeReportService.activateLoader();
    this.sellerIncomeReportService.setParams(this.requestBody);
    const report = await this.sellerIncomeReportService.make();
    this.sellerIncomeReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
      if (this.requestBody.filterOptions) {
        let createdAt = this.requestBody.filterOptions.createdAt;
        //@ts-ignore
        this.requestBody.filterOptions.createdAt = this.getFormatedDate(createdAt.startDate, createdAt.endDate);
      }
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.sellerIncomeReportService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.sellerIncomeReportService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = { searchKey: event };
    } else {
      this.requestBody.searchOptions = undefined;
      this.sellerIncomeReportService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    this.requestBody.sortOptions = event.direction === "" ? {} : { [`${event.active}`]: event.direction }
    await this.updateTable();
    this.sellerIncomeReportService.loader().subscribe(val => (this.loading = val));
  }

  getFormatedDate(startDate: any, endDate: any) {
    //startDate = moment(startDate).tz('Africa/Cairo').format('YYYY-MM-DD') + " 00:00:00";
    //endDate = moment(endDate).tz('Africa/Cairo').format('YYYY-MM-DD') + " 23:59:59";

    startDate = moment(startDate).format('YYYY-MM-DD') + " 00:00:00";
    endDate = moment(endDate).format('YYYY-MM-DD') + " 23:59:59";
    return { startDate, endDate };
  }
}

